import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Platform, StyleSheet, TouchableOpacity, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import CustomBottomSheet from 'src/components/bottom-sheet';
import {selectrootsheettype} from '../../../../../selectors/SheetSelector';
import {isWeb, windowWidth} from '../../../../../constants';
import {showSheet} from '../../../../../actions/SheetActions';
import {CustomText} from '../../../../../components';
import PrimaryButton from '../../../../../components/primary-button/PrimaryButton.component';
import {VehicleDetail} from 'src/pages/damage/damage-list/components/VehicleDetail';
import {font} from '../../../../../theme/Font';
import SVG from '../../../../../imports/svg';
import {Shadow} from 'react-native-shadow-2';
import {selecetvehivletype} from '../../../../../selectors/Vehicle';
import EmptyBox from '../../../../../components/empty-box/EmptyBox.component';
import {getVehicle} from '../../../../../actions/vehicle';
import {getModal} from '../../../../../actions/modal';
import {useHistory} from '../../../../../imports/Router';
import {checkPermitionAndGetPosition} from '../../../../../utils/location';
import {useApi} from '../../../../../providers/ApiProvider';
import {useMutation} from 'react-query';
import {getVehicleslist} from '../../../../../actions/vehicleslist';
import {selectconfigtype} from '../../../../../selectors/config';
import {selecetusertype} from '../../../../../selectors/User';
import {showAlert} from '../../../../../actions/AlertActions';
import {
  AnalyticsEvent,
  AnalyticsUserProperties,
} from 'src/services/analytics/FirebaseAnalytics';
import useVehiclesList from '../../../../../utils/VehiclesList';
import useCameraPermission from '../../../../../hooks/useCameraPermission';
import {selecetmaptype} from '../../../../../selectors/Map';
import Sentry from 'src/imports/sentry';
import {getApp} from '../../../../../actions/app';
import {getUser} from '../../../../../actions/user';

const ConfirmHealthSheet = () => {
  const bottomSheetRef = useRef(null);
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const {api} = useApi();
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );
  const {min_ride_Bicycle, min_ride_Bike} = useSelector(state =>
    selectconfigtype(state),
  );
  const [startLoading, setStartLoading] = useState(false);
  const {vehicle, reserveId} = useSelector(state => selecetvehivletype(state));
  const {userPosition} = useSelector(state => selecetmaptype(state));
  let minmon = vehicle.type == 'bike' ? min_ride_Bike : min_ride_Bicycle;
  const {reloadVehicleList} = useVehiclesList();
  const cameraPermission = useCameraPermission();
  const isWarMode = useSelector(state => state.config.is_war_mode);
  const closeBottomSheet = () => {
    dispatch(getModal({func: 'cancelReport', modal: false}));
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };

  const cancleReport = () => {
    dispatch(getModal({func: 'cancelReport', modal: false}));
    closeBottomSheet();
  };

  function openHandler() {
    if (isWeb) return;
    bottomSheetRef.current?.expand();
  }

  useEffect(() => {
    switch (sheetId) {
      case 'confirmHealth':
        openHandler();
        break;
      default:
        closeBottomSheet();
        break;
    }
  }, [sheetId]);
  const dashboardMyTripsMutation = useMutation({
    mutationFn: () => {
      return api.myActiveTrip();
    },
    onSuccess: response => {
      console.log(data?.ActiveTrip, 'data?.ActiveTrip');
      let data = response?.Data;
      if (data?.ActiveTrip) {
        dispatch(
          getVehicle({
            activeSeconds: data?.ActiveTrip?.ActiveSeconds,
            pauseSeconds: data?.ActiveTrip?.PauseSeconds,
            stop: data?.ActiveTrip?.LastDetailStatus == 'pause' ? true : false,
            activeMinutes: Math.round(data?.ActiveTrip?.ActiveSeconds / 60),
            pauseMinutes: Math.round(data?.ActiveTrip?.PauseSeconds / 60),
            money: data?.ActiveTrip?.Price,
          }),
        );
      }
    },
  });
  //trip start
  const tripsStartMutation = useMutation({
    mutationFn: async body => {
      return api.tripsStart(body);
    },
    onSuccess: response => {
      dispatch(getUser({needUploadImage: true}));
      dispatch(getApp({isFirstTry: true}));
      setStartLoading(false);
      let {id} = response?.Data;
      dispatch(
        getVehicleslist({
          type: 'parking',
        }),
      );
      dispatch(
        getVehicle({
          tripId: id,
          money: minmon * vehicle?.discounted_price,
          debtTripVehicleType: vehicle?.type,
          reserveId: null,
          reservetime: null,
          stop: false,
          activeSeconds: 0,
          pauseSeconds: 0,
          activeMinutes: 0,
          pauseMinutes: 0,
        }),
      );
      history.replace('/main/map/drive');
      dispatch(
        showSheet({
          sheetId: '',
        }),
      );

      dispatch(
        showAlert({
          id: 'AlertBox',
          modalProps: {
            icon: 'greenTick',
            title:
              vehicle?.type == 'Bike'
                ? t('motor_start_success')
                : t('bike_start_success'),
          },
        }),
      );
      AnalyticsEvent({
        type: 'trip',
        params: {
          trip_action: 'start_trip',
          trip_vehicle_type:
            vehicle?.type === 'Bicycle'
              ? 'bicycle'
              : vehicle?.type === 'Bike'
              ? 'motor'
              : vehicle?.type === 'Scooter'
              ? 'scooter'
              : '',
          trip_id: id,
        },
      }),
        AnalyticsEvent({
          type: 'trip',
          params: {
            trip_action: 'start_trip',
            trip_vehicle_type:
              vehicle?.type === 'Bicycle'
                ? 'bicycle'
                : vehicle?.type === 'Bike'
                ? 'motor'
                : vehicle?.type === 'Scooter'
                ? 'scooter'
                : '',
            trip_id: id,
          },
        });
      AnalyticsEvent({type: 'StartTrip'});
      AnalyticsUserProperties({
        user_trip_vehicle:
          vehicle?.type === 'Bicycle'
            ? 'bicycle'
            : vehicle?.type === 'Bike'
            ? 'moped'
            : vehicle?.type === 'Scooter'
            ? 'scooter'
            : '',
      });
    },
    onError: error => {
      setStartLoading(false);
      const errorType = error?.response?.data?.Result;
      const status = error?.response?.status;
      const errorMesage =
        error?.message === 'Network Error' ? 'Network Error' : errorType;
      Sentry.setTag('api_error', 'start_trip');
      Sentry.captureMessage(`Error Start trip ${errorMesage} - ${status}`);
      let error_list = ['Error_UnknownError'];
      if (errorType === 'Error_active_reserve_not_found') {
        dispatch(
          showSheet({
            sheetId: 'tripMessage',
            sheetProps: {
              type: 'reservation_has_ended',
            },
          }),
        );
        history.replace('/main/map');
        dispatch(
          getVehicle({vehicle: null, reservetime: null, reserveId: null}),
        );
        dispatch(
          getVehicleslist({
            liveActiveVehicle: null,
            marker: null,
          }),
        );
        reloadVehicleList();
      } else if (errorType === 'Error_Distance_not_valid') {
        if (Platform.OS === 'android') {
          cameraPermission().then(() => {
            history.push('/scanner');
            dispatch(showSheet({sheetId: ''}));
          });
        } else {
          dispatch(showSheet({sheetId: ''}));
          history.push('/scanner');
        }
      } else if (
        (errorType === 'Error_TryAgain' || errorType === 'TryAgain') &&
        vehicle?.type === 'Bicycle'
      ) {
        dispatch(
          showSheet({
            sheetId: 'tripMessage',
            sheetProps: {
              type: 'lock_stuck',
            },
          }),
        );
      }
      // Handle specific trip start errors
      else if (errorType === 'Error_DuplicateTripRequestDetected') {
        // Toast - خطای ساده
        displayErrorToast(
          errorType,
          [
            {
              key: 'Error_DuplicateTripRequestDetected',
              faMessage: t('Error_DuplicateTripRequestDetected'),
              faTitle: t('duplicate_request'),
            },
          ],
          {
            faMessage: t('Error_DuplicateTripRequestDetected'),
            faTitle: t('duplicate_request'),
          },
        );
        dashboardMyTripsMutation.mutate();
      } else if (errorType === 'Error_TripAlreadyStarted') {
        // Sheet - پیام مهم
        dispatch(
          showSheet({
            sheetId: 'tripMessage',
            sheetProps: {
              type: 'Error_TripAlreadyStarted',
            },
          }),
        );
        dashboardMyTripsMutation.mutate();
      } else {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title: error_list.includes(errorType)
                ? t(errorType)
                : t('an_unknown_error_occurred'),
            },
          }),
        );
      }
    },
  });

  const startTrip = () => {
    setStartLoading(true);
    dispatch(getVehicle({reportst: false}));

    console.log(isWarMode, 'isWarMode');
    if (isWarMode === true) {
      if (Platform.OS === 'android') {
        cameraPermission().then(() => {
          history.push('/scanner');
        });
      } else {
        history.push('/scanner');
      }
      setStartLoading(false);
      dispatch(
        showSheet({
          sheetId: '',
        }),
      );
      return;
    }
    checkPermitionAndGetPosition({
      onSuccess: position => {
        let mutationBody = {
          ReserveId: reserveId,
          Latitude: position.coords?.latitude,
          Longitude: position.coords?.longitude,
        };
        tripsStartMutation.mutate(mutationBody);
      },
      onError: err => {
        if (err.code !== 1) {
          let mutationBody = {
            ReserveId: reserveId,
            Latitude: userPosition?.lat ?? 0,
            Longitude: userPosition?.lng ?? 0,
          };
          tripsStartMutation.mutate(mutationBody);
        } else {
          setStartLoading(false);
          dispatch(
            showSheet({
              sheetId: '',
            }),
          );
          history.replace('/main/map/reserved');
        }
      },
    });
  };

  const reportDamage = () => {
    closeBottomSheet();
    history.replace('/main/damage-list');
  };

  return (
    <CustomBottomSheet
      onClose={closeBottomSheet}
      ref={bottomSheetRef}
      enablePanDownToClose={isWeb ? undefined : true}
      expandOnContentDrag={isWeb ? false : undefined}
      handleIndicatorStyle={styles.indicator}
      snapPoints={isWeb ? ({minHeight}) => [1, minHeight] : [419]}
      onSpringEnd={
        isWeb
          ? () => {
              if (bottomSheetRef?.current?.height < 2) {
                dispatch(getModal({func: 'cancelReport', modal: false}));
                dispatch(showSheet({sheetId: ''}));
              }
            }
          : undefined
      }
      defaultSnap={isWeb ? 419 : undefined}
      open={sheetId !== ''}
      scrollViewStyle={isWeb ? undefined : styles.scroll}
      blocking={isWeb ? true : undefined}
      scrollLocking={isWeb ? false : undefined}>
      <View style={styles.content}>
        <View style={styles.closeContainer}>
          <CustomText size={18} font="700">
            {t('do_you_confirm_vehicle_health')}
          </CustomText>
          <Shadow
            offset={[0, 0]}
            distance={5}
            containerStyle={styles.shadowContainer}
            style={{}}>
            <TouchableOpacity
              onPress={cancleReport}
              style={styles.closeTouchable}>
              <SVG width={12} height={12} name={'closeSimple'} />
            </TouchableOpacity>
          </Shadow>
        </View>
        <EmptyBox height={24} />
        <CustomText size={15} font={'500'}>
          {t(
            'check_your_reserved_device_and_use_another_device_if_it_breaks_down',
          )}
        </CustomText>
        <EmptyBox height={24} />

        {console.log(vehicle, 'vehicle')}
        <VehicleDetail hasIcon item={vehicle} />
        <CustomText
          mt={52}
          mb={10}
          txtAlign="center"
          size={12}
          font={'400'}
          color={'#07BE00'}>
          {t('travel_time_will_be_calculated_after_your_confirmation')}
        </CustomText>
        <PrimaryButton
          containerStyle={styles.hasProblemButton}
          textStyle={styles.hasProblemText}
          onPress={reportDamage}
          title={t('no_vehicle_has_some_problems')}></PrimaryButton>
        <PrimaryButton
          containerStyle={styles.confirmButton}
          textStyle={styles.btnText}
          onPress={startTrip}
          isLoading={startLoading}
          title={t('confirm_the_vehicle_health')}
        />
      </View>
    </CustomBottomSheet>
  );
};

export default ConfirmHealthSheet;

const styles = StyleSheet.create({
  scroll: {},
  loading: {
    left: 40,
  },
  btnText: {
    fontSize: 16,
    fontFamily: font['500'],
    marginRight: 8,
  },
  hasProblemButton: {
    width: windowWidth - 30,
    justifyContent: 'center',
    flexDirection: 'row-reverse',
    borderWidth: 1,
    borderColor: '#CFCFCF',
    height: 40,
    alignSelf: 'center',
    backgroundColor: '#fff',
    paddingBottom: 0,
    paddingTop: 0,
  },
  closeTouchable: {
    backgroundColor: '#fff',
    padding: 8,
    borderRadius: 50,
  },
  closeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  closeContainer: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  indicator: {
    width: 72,
  },
  hasProblemText: {
    fontSize: 16,
    fontFamily: font['500'],
    color: '#2D2D2D',
    marginRight: 8,
  },
  shadowContainer: {
    marginLeft: 8,
    top: 3,
  },
  confirmButton: {
    marginTop: 10,
    flexDirection: 'row-reverse',
    justifyContent: 'center',
    width: windowWidth - 30,
    marginBottom: 24,
    paddingBottom: 0,
    paddingTop: 0,
    height: 40,
    alignSelf: 'center',
  },
  content: {
    width: windowWidth - 30,
    marginHorizontal: 15,
    alignSelf: 'center',
  },
});
